var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1291_13003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.801H24V5.04098L18.6947 0.000976562H0",
    fill: "#3980FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6961 5.04098H24.0014L18.6961 0.000976562",
    fill: "#9EC2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0014 10.081V5.04102H18.6961",
    fill: "#1F53B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68085 11.855H18.3124V10.583H5.68085M5.68085 14.603H18.3124V13.337H5.68085M5.68085 17.357H18.3124V16.085H5.68085M5.68085 19.895H13.2598V18.839H5.68085",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1291_13003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28.8,
    rx: 4.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentFile);
export default __webpack_public_path__ + "static/media/attachment-file.0d4505f18dd78e94006c944bbfa2c59a.svg";
export { ForwardRef as ReactComponent };